<app-header></app-header>
<section class="bredcrumb">
  <div class="container">
    <ul class="brd-nav">
      <li><a [routerLink]="['/']"> Home </a></li>
      <li><a [routerLink]="['/labs/list']"> Labs </a></li>
      <li><span> {{ labDetail.name }} </span></li>
    </ul>
  </div>
</section>
<!-- End of bredcrumb -->

<section class="single-page labs-detail doctors-detail padd-row">
  <div class="container">
    <div class="row">
      <div class="col-lg-4">
        <div class="doc-detail-lft grey-bg sidebar">
          <div class="doc-detail-box btm-line mt-0 pt-0">
            <div class="doctor-box-top">
              <div style="cursor:pointer" (click)="showImagePopup(labDetail.profilePicture)" class="doctor-box-img">
                <img [src]="labDetail.profilePicture" alt="image">
              </div>
              <div class="doctor-box-top-cnt">
                <h5> {{ labDetail.name }} <span *ngIf="labDetail.discount>0"> {{ labDetail.discount }}
                  % OFF on Lab Tests </span></h5>
                <div class="doctor-box-rating">
                  <i class="fa fa-star" aria-hidden="true"></i>
                  <span> {{ !labDetail.averageRatings ? 0 : labDetail.averageRatings }}
                    | {{ labDetail?.review?.length }} Reviews </span>
                  <p> Registered Lab <img style="width:30px;height:30px" src="assets/images/bluetick.png"></p>
                </div>
              </div>
            </div>
            <div class="hos-detail-adrs-top-sidebar btm-line">
                <p> <strong> Address </strong></p>
                <p><a target="_blank" 
                    [href]="'https://www.google.com/maps/place/'+labDetail?.address"> 
                    <i class="fa fa-map-marker" aria-hidden="true"></i>{{ labDetail?.address }}</a>  </p>
             
                <!-- <p> <strong> Phone Number </strong></p>
                <p> {{ labDetail?.phoneNo }}  
                    {{ labDetail?.alternateNumber ? '| '+labDetail?.alternateNumber : ''  }}

                     </p> -->

                     <p><strong> Timing</strong></p>
                     <p [hidden]="single?.timing==''" *ngFor="let single of availability"> <i [ngStyle]="{ 'color': single.error ? 'red' : '#26abe3' }"  class="fa fa-calendar-check-o" aria-hidden="true"></i>
                        {{ single.timing }}
                     </p>
               
            </div>
            <!-- <div class="doc-detail-btm">
              <ul>
                <li><a target="_blank" [href]="'https://www.google.com/maps/place/'+labDetail.address"> <i
                  class="fa fa-map-marker" aria-hidden="true"></i> {{ labDetail.address }}</a></li>
                <ng-template [ngIf]="availability.length>0" #avilability>

                  <li [ngStyle]="{ 'color': single.error ? 'red' : 'none' }" [hidden]="single?.timing==''"
                      *ngFor="let single of availability"><i [ngStyle]="{ 'color': single.error ? 'red' : '#26abe3' }"
                                                             class="fa fa-calendar-check-o"
                                                             aria-hidden="true"></i> {{ single.timing }} </li>
                </ng-template>
              </ul>
            </div> -->
          </div>
          <div *ngIf="labDetail?.images.length>0" class="labs-details-images btm-line">
            <h3> Images </h3>
            <ul class="clearfix">
              <li (click)="showImages()" *ngFor="let image of labDetail.images"><img [src]="image" alt="image"></li>
              <!-- <li> <img src="assets/images/lab-detail-img-2.jpg" alt="image"> </li>
              <li> <img src="assets/images/lab-detail-img-3.jpg" alt="image"> </li>
              <li> <img src="assets/images/lab-detail-img-2.jpg" alt="image"> </li>
              <li> <img src="assets/images/lab-detail-img-3.jpg" alt="image"> </li>
              <li> <img src="assets/images/lab-detail-img-1.jpg" alt="image"> </li> -->
            </ul>
          </div>
          <div *ngIf="labDetail?.review.length>0" class="labs-reviews-sum">
            <h3> Review Summary </h3>
            <div class="labs-reviews-sum-prgs-bar">
              <div class="lab-reviws-prgs-box">
                <label> 5 </label>
                <div class="progress">
                  <div class="progress-bar" [style.width]="labDetail.starsCount_Five+'%'"></div>
                </div>
              </div>
              <div class="lab-reviws-prgs-box">
                <div class="progress">
                  <label> 4 </label>
                  <div class="progress-bar" [style.width]="labDetail.starsCount_Four+'%'"></div>
                </div>
              </div>
              <div class="lab-reviws-prgs-box">
                <div class="progress">
                  <label> 3 </label>
                  <div class="progress-bar" [style.width]="labDetail.starsCount_Three+'%'"></div>
                </div>
              </div>
              <div class="lab-reviws-prgs-box">
                <div class="progress">
                  <label> 2 </label>
                  <div class="progress-bar" [style.width]="labDetail.starsCount_Two+'%'"></div>
                </div>
              </div>
              <div class="lab-reviws-prgs-box">
                <div class="progress">
                  <label> 1 </label>
                  <div class="progress-bar" [style.width]="labDetail.starsCount_One+'%'"></div>
                </div>
              </div>
            </div>
            <ul>
              <li *ngFor="let review of labReviews">
                <img [src]="review?.userId?.profilePicture" alt="image">
                <p> "{{ review.comment }}" </p>
              </li>

            </ul>
          </div>
        </div>
      </div>

      <div class="col-lg-8">
        <div class="doc-detail-nav">
          <ul class="nav nav-pills">
            <li class="nav-item">
              <a class="nav-link active" data-toggle="pill" (click)="scroll(target)" href="#lab-details-1"> About </a>
            </li>
            <li *ngIf="labShow?.length>0" class="nav-item">
              <a class="nav-link" data-toggle="pill" (click)="scroll(target1)" href="#lab-details-2"> Lab Tests </a>
            </li>
            <li *ngIf="labDetail?.review?.length>0" class="nav-item">
              <a class="nav-link" data-toggle="pill" (click)="scroll(target2)" href="#lab-details-3"> Reviews </a>
            </li>
          </ul>
        </div>
        <div class="doc-detail-right tab-content">
          <div #target class="tab-pane active" id="lab-details-1j">
            <div class="doc-detail-right-main">
              <div class="doc-detail-cnt pt-0 btm-line">
                <h3> About </h3>
                <p class="mb-0"> {{ labDetail.about }} </p>
              </div>

            </div>
          </div>
          <div #target1 id="lab-details-2j">
            <div *ngIf="labShow?.length>0" class="doc-detail-right-main">

              <div class="lab-details-test doc-detail-cnt btm-line">
                <h3>Lab Tests</h3>
                <div class="row">
                  <div *ngFor="let labTest of labShow" class="col-md-6">
                    <div class="lab-details-test-box">
                      <div class="lab-details-test-box-top-cnt">
                        <div class="d-flex">
                          <!---  {{ labTest.name.slice(0, 10) }} {{ labTest.name.length > 10 ? '...' : '' }} -->
                          <h5>  <read-more [text]="labTest?.name" [maxLength]="30" [showToggleButton]="true"></read-more></h5>

                          <div class="price"><span class="cut-price"
                                                   *ngIf="labDetail.discount!=0"> {{ labTest.price }} </span> {{ 'Rs. ' + getPriceAfterDiscount(labTest.price, labDetail.discount) + '/-' }}
                          </div>

                        </div>
                      </div>
                      <div class="lab-details-test-box-btm-cnt">
                        <div class="d-flex">
                          <p> {{ labTest.description.slice(0, 100) }}{{ labTest.description.length > 100 ? '...' : '' }}</p>
                          <div class="lab-test-incre-decre text-right">
                            <i class="fa fa-minus" (click)="updateTest(-1,labTest?._id,labTest)" aria-hidden="true"></i>
                            <span> {{ labTest.quantity }} </span>
                            <i class="fa fa-plus" (click)="updateTest(1,labTest?._id,labTest)" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="lab-details-test-btm-btns">
                  <!-- <a routeeLink="null" (click)="clearTest()" class="btn-style btn-style-border"> Clear All </a> -->
                  <a routeeLink="null" *ngIf="sendLabData.length>0" (click)="loginFirst()" class="btn-style"> Next
                    <!-- <span class="price-btn-txt" > Rs. {{ totalAmount }}/- </span> -->
                  </a>
                  <!-- <a *ngIf="!isLoggedIn && sendLabData.length>0" routeeLink="null"  (click)="loginFirst()"  class="btn-style"> Book Test <span class="price-btn-txt" > Rs. {{ totalAmount }}/- </span> </a> -->
                </div>
              </div>

            </div>
          </div>
          <div #target2 id="lab-details-3j">
            <div *ngIf="labDetail?.review?.length>0" class="doc-detail-right-main">
              <div class="doc-detail-client-reviews doc-detail-cnt">
                <h3> Reviews </h3>
                <ul class="doc-detail-clint-reviews-slider">
                  <ngx-slick-carousel class="carousel"
                                      #slickModal4="slick-carousel"
                                      [config]="slideConfigCustomers"
                  >
                    <li *ngFor="let review of labDetail?.review" ngxSlickItem>
                      <div class="client-review-box">
                        <div class="client-review-box-img">
                          <img [src]="review?.userId?.profilePicture" alt="image">
                        </div>
                        <div class="client-review-box-cnt">
                          <h5> {{ review?.userId?.name }} </h5>
                          <p> "{{ review?.comment }}"</p>
                          <i *ngFor='let in of counter(review?.stars) ;let i = index' class="fa fa-star"
                             aria-hidden="true"></i>
                          <i class="fa fa-star-o" *ngFor='let in of counter(5- review?.stars) ;let i = index'
                             aria-hidden="true"></i>

                          <span> {{ !review.stars ? 0 : review.stars }} </span>
                        </div>
                      </div>
                    </li>
                  </ngx-slick-carousel>

                </ul>
              </div>

              <!-- <div class="doc-detail-client-reviews doc-detail-cnt">
                  <h3> Reviews </h3>
                  <section class="our-customers">
                          <div class="our-customers-main">
                          <ngx-slick-carousel class="carousel"
                          #slickModal4="slick-carousel"
                          [config]="slideConfigCustomers"
      >

            <div *ngFor="let review of labDetail?.review" ngxSlickItem class="slider">
        <div class="our-customers-box_phar">
            <div class="client-review-box-img_phar">
                <img [src]="review?.userId?.profilePicture" alt="image">
            </div>
            <div class="client-review-box-cnt_phar">
                <h5> {{ review?.userId?.name }} </h5>
                <p> "{{ review?.comment }}"</p>
                <i *ngFor='let in of counter(review?.stars) ;let i = index' class="fa fa-star" aria-hidden="true"></i>
                          <i class="fa fa-star-o"   *ngFor='let in of counter(5- review?.stars) ;let i = index'  aria-hidden="true"></i>

                <span> {{ !review.stars ? 0 : review.stars }} </span>
            </div>

        </div>
             </div>

    </ngx-slick-carousel>
    </div>
    </section>
    </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End of doctors-detail -->

<input type="hidden" #closeconfirmation data-toggle="modal" id="order_confirm" data-target="#order-confirmed">
<!-- The Modal -->
<div class="modal fade" id="order-confirmed">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body">
        <div class="sign-up-form order-confirmed">
          <h2 class="text-center"><span> Order Confirmed </span></h2>
          <h5> Congratulations! Your order is confirmed. </h5>
          <h5> You Can review your order </h5>
          <a routeeLink="null" (click)="closeconfirmation.click()" class="btn-style"> Ok </a>
        </div>
      </div>
    </div>
  </div>
</div>

<input type="hidden" data-toggle="modal" id="address_lab" data-target="#order-address">

<div class="modal fade" data-backdrop="static" id="order-address">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body">
        <div class="sign-up-form add-doc-form">
          <div class="add-doc-ambu-cmn add-treat-form">
            <h2> Add Address </h2>
            <form class="doctors-edit-main p-0 no-shadow">
              <div class="doctors-edit-lft">
                <div class="edit-profile-form-rows">
                  <div class="row no-gutters">
                    <div class="col-md-12">
                      <label> Address </label>
                      <input type="text" name="user_address" id="user_address_lab" (keypress)="checkAddress()"
                             (onAddressChange)="handleAddressChange($event)" [options]='options'
                             ngx-google-places-autocomplete #placesRef="ngx-places" [(ngModel)]="addressFields.address"
                             class="form-control" placeholder="Enter Your Address">

                    </div>
                    <div class="col-md-12">
                      <div id="mapLocation"></div>
                      <div class="centerMarker"></div>
                    </div>
                    <div class="col-md-12">
                      <label> City </label>
                      <input type="text" name="user_city" d="user_city_lab" class="form-control"
                             [(ngModel)]="addressFields.city" placeholder="Enter City">
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <input class="form-control"
                               placeholder="Select Date"
                               ngModel
                               container=""
                               name="datebook"
                               bsDatepicker
                               #dp="bsDatepicker"
                               [minDate]="minDateValue"
                               (ngModelChange)="changed()"
                               [bsConfig]="{ dateInputFormat: 'MMMM Do YYYY' }"
                               [(bsValue)]="valueDate"
                        >
                        <!-- <ejs-datetimepicker [min]='minDateValue' [minuteStep]="30" id='datetimepicker' placeholder='Select  Date & Time...' name="dateTime" format ='dd MMM,yyyy  HH:mm a' [(ngModel)]='valueDate' ></ejs-datetimepicker> -->
                        <!-- <p-calendar class="form-control"   [minDate]="minDateValue"  [(ngModel)]="valueDate" name="datebook" [stepMinute]=30 dateFormat="dd M yy" [showTime]="true" [hourFormat]="12"></p-calendar> -->
                      </div>
                      <div class="col-md-6 input-group" >


                        <div class="input-group-prepend">
                        <span class="input-group-text"> <i class="fa fa-clock-o" (click)="open()"
                                                           aria-hidden="true"></i></span>
                        </div>

                        <input disabled="true" placeholder="hh:mm" class="form-control" required (click)="open()"
                               name="openHrsLab" [value]="timeobj.openTimeString" [(ngModel)]="timeobj.openTimeString"/>
                        <input disabled="true" placeholder="am" class="form-control" required (click)="open()"
                               name="openMeridian" [value]="timeobj.openTimeMeridian"
                               [(ngModel)]="timeobj.openTimeMeridian"/>

                      </div>
                      <!-- <timepicker minuteStep="30" (ngModelChange)="changed()" name="booktime" class="time_lab" [(ngModel)]="valueTime"
                     ></timepicker> -->
                    </div>
                    <div class="col-md-12">
                      <div class="add-doc-btns-btm mt-3">
                        <!-- <button type="submit"    class="btn-style no-shadow"> Save </button>
                        <button type="button"  class="btn-style btn-style-grey  no-shadow" data-dismiss="modal"> Cancel </button> -->
                        <button type="button" [disabled]="isDisable" (click)="gotoCart()"
                                class="btn btn-style no-shadow"> Next
                        </button>
                        <a href="javascript://" class="btn-style btn-style-grey  no-shadow" (click)="removeLabData()"
                           data-dismiss="modal"> Cancel </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


<input type="hidden" data-toggle="modal" id="lab_order_details_trigger" data-target="#lab_order_details">

<div class="modal fade" id="lab_order_details">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body">

        <div class="row">

          <div class="col-lg-12">
            <div class="labs-order-left-side">
              <div class="row">
                <div *ngFor="let labTest of labCartData" class="col-md-6">
                  <div class="lab-ordr-list-box lab-details-test-box">
                    <div class="lab-details-test-box-top-cnt">
                      <div class="d-flex">
                        <h5> {{ labTest?.name?.slice(0, 10) }} {{ labTest?.name?.length > 10 ? '...' : '' }} </h5>

                        <div class="price" (click)="removeFromCart(labTest)"> Remove</div>
                      </div>
                    </div>
                    <p> {{ labTest?.description?.slice(0, 100) }}{{ labTest?.description?.length > 100 ? '...' : '' }} </p>
                    <div class="lab-details-test-box-btm-cnt">
                      <div class="d-flex">
                        <div class="lab-test-incre-decre text-left">
                          <i class="fa fa-minus" (click)="updateTest(-1,labTest?._id,labTest)" aria-hidden="true"></i>
                          <span> {{ labTest?.quantity }} </span>
                          <i class="fa fa-plus" (click)="updateTest(1,labTest?._id,labTest)" aria-hidden="true"></i>
                        </div>

                        <div class="price">
                          <!-- <span class="cut-price" *ngIf="labDetail.discount!=0"> {{ labTest?.price }} </span>  -->
                          {{ 'Rs. ' + getPriceAfterDiscount(labTest?.price, labDetail.discount) + '/-' }} </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>

          <div class="col-lg-12">
            <div class="doc-detail-lft p-0 sidebar">

              <div class="doc-detail-box grey-bg p-25-side mb-4">
                <div class="labs-orders-side-box">
                  <div class="labs-orders-side-box-head">
                    <h4> Delivery Address <span (click)="gotoCart()"> Add new </span></h4>
                  </div>
                  <div class="labs-orders-side-box-body">
                    <ul>
                      <li>
                        <p> {{ addressFields.address }}, {{ addressFields.city }}  </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="doc-detail-box grey-bg p-25-side mb-4">
                <div class="labs-orders-side-box">
                  <!-- <div class="labs-orders-side-box-head">
                      <h4> Summary </h4>
                  </div>
                  <div class="labs-orders-side-box-body">
                      <ul>
                          <li>
                              <p> Subtotal </p>
                              <div class="order-price"> Rs. 3500/- </div>
                          </li>
                          <li>
                              <p> Taxes </p>
                              <div class="order-price"> Rs. 1000/- </div>
                          </li>
                      </ul>
                  </div> -->
                  <div class="labs-orders-side-box-ftr">
                    <div class="labs-orders-side-box-body">
                      <ul>
                        <li>
                          <p><strong> Total Amount </strong></p>
                          <div class="order-price"> Rs. {{ totalAmount }}/-</div>
                        </li>
                      </ul>
                    </div>
                    <a [routerLink]="null" *ngIf="sendLabData.length>0" (click)="payWithRazor()" class="btn-style">
                      Proceed to Payment </a>
                  </div>
                </div>
              </div>


            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


<input type="hidden" id="orderImagesCLick" data-toggle="modal" data-target="#orderImagesModal">

<!-- The Modal -->
<div class="modal fade" id="orderImagesModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Images</h5>
      </div>
      <!-- Modal body -->
      <div class="modal-body text-center">
        <slideshow
          [minHeight]="'525px'"
          [showArrows]="imageUrlArray.length>1 ? true: false"
          [imageUrls]="imageUrlArray"></slideshow>
        <button class="btn btn-primary" style="margin-top: 20px;"
                data-toggle="modal" data-target="#orderImagesModal">OK
        </button>

      </div>
    </div>
  </div>
</div>

